import { convertParams } from 'src/utils/utils'
import axios from '../axios'
import { EMPLOYEEROUTES } from 'src/router/Api'

export const getListEmployee = async (params) => {
	return await axios.get(EMPLOYEEROUTES.name, {
		params: convertParams(params),
	})
}

export const getOneEmployee = async (id, params) => {
	return await axios.get(`${EMPLOYEEROUTES.name}/${id}`, {
		params: convertParams(params),
	})
}

export const createEmployee = async (payload) => {
	return await axios.post(EMPLOYEEROUTES.name, payload)
}

export const updateEmployee = async (id, payload) => {
	return await axios.put(`${EMPLOYEEROUTES.name}/${id}`, payload)
}

export const changeEmployeePassword = async (payload) => {
	return await axios.put(EMPLOYEEROUTES.change_password, payload)
}

export const getEmployeeProfile = async () => {
	return await axios.get(`${EMPLOYEEROUTES.name}/profile`)
}
